<template>
  <div
    class="colored-div"
    :style="{ backgroundColor: cellData || '#FFFFFF' }"
  />
</template>

<script>
export default {
  name: 'ColoredCell',

  props: {
    cellData: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.colored-div {
  width: 30px;
  height: 30px;
  border-radius: 4px;
}
</style>
